import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import {LunaLoader} from './widgets/lunaloader/lunaloader.component'

import ItineraryTopContainer from './itinerary/itinerarytop.container'
import ItineraryBottomContainer from './itinerary/itinerarybottom.container'
// import SidebarContainer from './sidebar/sidebar.container'
import AppFooter from './appfooter/appfooter.container'
import MobileHeaderContainer from './mobile/mobileheader.container'
import LunaHelpModalContainer from './widgets/lunahelpmodal/lunahelpmodal.container'

export class App extends React.Component {
    constructor(props) {
        super(props)

        this._timerRunning = false
        this._clicks = 0
        this._maxClicks = 10 // after this many clicks, show the second lunatrip modal

        this.state = {
            showingLoader: this.props.socketLoaded ? false : true,
            showHelp: false,
            helpType: 'welcome', // planner-hints, luna-timer, welcome
            helpTimer: false
        }

        _.bindAll(this,
            'getContent',
            'onFadeLoader',
            'onToggleHelp',
            'setHelpTimer'
        )
    }  

    componentDidMount() {    
        let self = this  
        if (window.payload.action === 'INITIALIZE' && !this.props.isLunaTrip) {
            // is this in an init state and not a luna trip? show the welcome message
            this.setState({showHelp: true, helpType: 'welcome'})
        } else if (this.props.isLunaTrip) {      
            // is this a Luna trip? Load up the luna-trip help and start counting mouse clicks 
            document.addEventListener('mousedown', function() {self.setHelpTimer()}, false) 
            this.setState({showHelp: false, helpType: 'luna-trip'})
        }
    }

    setHelpTimer() {    
        let self = this  
        self._clicks++ 
        if (self._clicks === self._maxClicks) {
            // Using a timer triggered after x number of clicks to show make sure any other help modals are closed      
            let lunaTripTimer = _.debounce(function(e) {        
                self._timerRunning = false
                if (!self.state.showHelp) {
                    self.setState({helpType: 'luna-timer', showHelp: true})
                    // TODO: set cookie, confirm we only ever want to show this once?
                } else {
                    // need to call self again as another modal was open
                    lunaTripTimer()
                }
            }, 1000) 
            if (!this._timerRunning) {
                this._timerRunning = true
                lunaTripTimer()
            }
        }
    }

    onToggleHelp(type, timer) {
        let newType = type ? type : this.state.helpType // optional param used to reset luna trip timer type
        let newTimer = timer ? timer : this.state.timer

        if (this.state.showHelp) {
            // user closed the window, if this is a luna trip and we want the timer, check that bool
            if (this.state.helpTimer) {
                this.setState({showHelp: false, helpTimer: false})
            } else {
                // just close it
                this.setState({showHelp: false})
            }
        } else {
            this.setState({showHelp: true, helpType: newType, helpTimer: newTimer})
        }
    }

    onFadeLoader() {
        this.setState({showingLoader: false})
    }

    getContent(sbClass) {
        if (!this.state.showingLoader) {
            if (!_isMobile) {
                return (
                    <div id="app-container">
                        <LunaHelpModalContainer type={this.state.helpType} showHelp={this.state.showHelp} onToggleHelp={this.onToggleHelp}/>
                        <div id="main-container" className="itinerary-container">
                            <ItineraryTopContainer onToggleBooking={this.props.onToggleBooking}/>
                            <ItineraryBottomContainer bookingActive={this.props.bookingActive} onToggleBooking={this.props.onToggleBooking} onToggleHelp={this.onToggleHelp}/>
                            <AppFooter/>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div id="app-container">
                        <LunaHelpModalContainer type={this.state.helpType} showHelp={this.state.showHelp} onToggleHelp={this.onToggleHelp}/>
                        <div id="main-container" className="itinerary-container">
                            <MobileHeaderContainer/>
                            <ItineraryBottomContainer onToggleHelp={this.onToggleHelp}/>
                            <AppFooter/>
                        </div>
                    </div>
                )
            }
        } else {
            return <LunaLoader triggerFade={this.props.socketLoaded} onFadeLoader={ this.onFadeLoader }/>
        }
    }

    render() {
        return (
            <div id="app-container">
                { this.getContent() }
            </div>
        )
    }
}
